export const NAVEGACION_ENDPOINTS = {
  MENU: '/api/v1/navegacion/menu',
} as const;

export const USUARIOS_ENDPOINTS = {
  LISTAR: '/api/v1/usuarios',
  OBTENER: (id: number) => `/api/v1/usuarios/${id}`,
  CREAR: '/api/v1/usuarios',
  ACTUALIZAR: (id: number) => `/api/v1/usuarios/${id}`,
  DESACTIVAR: (id: number) => `/api/v1/usuarios/${id}`,
  ASEGURADORAS_DISPONIBLES: '/api/v1/usuarios/aseguradoras-disponibles',
} as const;

export const ROLES_ENDPOINTS = {
  LISTAR: '/api/v1/roles',
  OBTENER: (id: number) => `/api/v1/roles/${id}`,
  CREAR: '/api/v1/roles',
  ACTUALIZAR: (id: number) => `/api/v1/roles/${id}`,
  ELIMINAR: (id: number) => `/api/v1/roles/${id}`,
  ASIGNAR_PERMISOS: (rolId: number) => `/api/v1/roles/${rolId}/permisos`,
  REMOVER_PERMISOS: (rolId: number) => `/api/v1/roles/${rolId}/permisos`,
} as const;

export const PERMISOS_ENDPOINTS = {
  LISTAR: '/api/v1/permisos',
  OBTENER: (id: number) => `/api/v1/permisos/${id}`,
} as const;

export const SESIONES_ENDPOINTS = {
  LISTAR: '/api/v1/auth/sesiones',
  REVOCAR: (id: number) => `/api/v1/auth/sesiones/${id}`,
} as const;

export const PLANTILLAS_ENDPOINTS = {
  LISTAR: '/api/v1/plantillas',
  OBTENER: (id: number) => `/api/v1/plantillas/${id}`,
  ACTUALIZAR: (id: number) => `/api/v1/plantillas/${id}`,
  DESACTIVAR: (id: number) => `/api/v1/plantillas/${id}`,
} as const;

export const ENVIOS_ENDPOINTS = {
  LISTAR: '/api/v1/envios',
  OBTENER: (id: number) => `/api/v1/envios/${id}`,
  REENVIAR: (id: number) => `/api/v1/envios/${id}/reenviar`,
} as const;

export const ORGANIZACIONES_ENDPOINTS = {
  LISTAR: '/api/v1/organizaciones',
  OBTENER: (id: number) => `/api/v1/organizaciones/${id}`,
  CREAR: '/api/v1/organizaciones',
  ACTUALIZAR: (id: number) => `/api/v1/organizaciones/${id}`,
} as const;

export const APLICACIONES_ENDPOINTS = {
  LISTAR: '/api/v1/aplicaciones',
  OBTENER: (id: number) => `/api/v1/aplicaciones/${id}`,
  CREAR: '/api/v1/aplicaciones',
  ACTUALIZAR: (id: number) => `/api/v1/aplicaciones/${id}`,
} as const;

export const SMTP_ENDPOINTS = {
  LISTAR: '/api/v1/smtp',
  OBTENER: (id: number) => `/api/v1/smtp/${id}`,
  CREAR: '/api/v1/smtp',
  ACTUALIZAR: (id: number) => `/api/v1/smtp/${id}`,
} as const;

export const PARAMETROS_ENDPOINTS = {
  LISTAR: '/api/v1/parametros',
  OBTENER: (id: number) => `/api/v1/parametros/${id}`,
  CREAR: '/api/v1/parametros',
  ACTUALIZAR: (id: number) => `/api/v1/parametros/${id}`,
  ELIMINAR: (id: number) => `/api/v1/parametros/${id}`,
  TIPOS: '/api/v1/parametros/tipos',
  PADRES: '/api/v1/parametros/padres',
} as const;
